import { UserRole } from 'shared/types/userRole';
import { PermissionManagerFactory } from '../permissionManagerFactory';
import { PermissionConfig } from '../types';

export const CREATE_ORGANIZATION_PERMISSIONS: PermissionConfig = {
  [UserRole.superAdmin]: true,
  [UserRole.organizationAdmin]: true,
  [UserRole.projectAdmin]: true,
  [UserRole.manager]: true,
  [UserRole.viewer]: true,
  [UserRole.standard]: true,
  [UserRole.visible_no_access]: false,
};

export const EDIT_ORGANIZATION_PERMISSIONS: PermissionConfig = {
  [UserRole.superAdmin]: true,
  [UserRole.organizationAdmin]: true,
  [UserRole.projectAdmin]: false,
  [UserRole.manager]: false,
  [UserRole.viewer]: false,
  [UserRole.standard]: false,
  [UserRole.visible_no_access]: false,
};

export const OrganizationPermissionManager =
  PermissionManagerFactory.create({
    permissionConfigForCreate: CREATE_ORGANIZATION_PERMISSIONS,
    permissionConfigForEdit: EDIT_ORGANIZATION_PERMISSIONS,
    permissionConfigForDelete: null,
  });
